module.exports = __webpack_public_path__ + "static/fonts/ionicons.d535a25.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/view-design/dist/styles/fonts/ionicons.ttf?v=3.0.0
// module id = 565
// module chunks = 8